import { jsxs, jsx } from "react/jsx-runtime";
import dayjs from "dayjs";
import { InsetIcon, ClockIcon } from "../Icons/index.es.js";
import stitches from "../theme.config.es.js";
import en from "./en.es.js";
import EzSelect from "./EzSelect.es.js";
import useTranslation from "../../utils/hooks/useTranslation.es.js";
const repeat = (n) => new Array(n).fill(null);
const formatTime = (time) => time.toLocaleLowerCase().replace(/([0-9]{2})([a-z]{2})$/u, "$1 $2");
const useTimeRangeOptions = ({ start, end, step }) => {
  const { t } = useTranslation(en);
  const date = dayjs().format(t("DATE_FORMAT"));
  const startTime = dayjs(`${date} ${formatTime(start)}`);
  const endTime = dayjs(`${date} ${formatTime(end)}`);
  const interval = Math.floor(endTime.diff(startTime, "minute") / step) + 1;
  return repeat(interval).map((_, i) => startTime.add(step * i, "minute").format(t("TIME_FORMAT")));
};
const layout = stitches.css({
  "@baseToMedium": {
    maxWidth: "160px",
    width: "auto"
  },
  position: "relative",
  width: "160px",
  input: { paddingLeft: "2.5em" }
});
const EzTimeInput = ({
  start,
  end,
  step = 60,
  value,
  displayAsNoon = false,
  focusLabel = "",
  ...rest
}) => {
  const { t } = useTranslation(en);
  const date = dayjs().format(t("DATE_FORMAT"));
  const valueTime = dayjs(`${date} ${value}`);
  const valueTimeString = valueTime.format(t("TIME_FORMAT"));
  const { error, touched } = rest;
  const options = useTimeRangeOptions({ start, end, step });
  const selectOptions = options.map((option) => ({
    label: option === "12:00 PM" && displayAsNoon ? t("NOON") : option,
    value: option
  }));
  return /* @__PURE__ */ jsxs("div", { className: layout(), children: [
    /* @__PURE__ */ jsx(InsetIcon, { insetY0: true, left0: true, pl3: true, children: /* @__PURE__ */ jsx(ClockIcon, {}) }),
    /* @__PURE__ */ jsx(
      EzSelect,
      {
        id: rest.id,
        label: rest.label,
        ...{ error, touched },
        placeholder: rest.placeholder,
        options: selectOptions,
        value: valueTimeString,
        onChange: rest.onChange,
        "aria-labelledby": rest["aria-labelledby"],
        disabled: rest.disabled,
        focusLabel,
        classNameSuffix: rest.classNameSuffix
      }
    )
  ] });
};
export {
  EzTimeInput as default
};
//# sourceMappingURL=EzTimeInput.es.js.map
